<template>
  <app-form-group design="new" :label="label">
    <div ref="root" class="dictionary-field">
      <div class="dictionary-field__control">
        <app-select
          :key="selectKey"
          :value="value"
          design="new"
          :options="options"
          :multiple="multiple"
          label="name"
          :placeholder="canCreate ? `Search or create ${singular.toLowerCase()}` : placeholder"
          :disabled="disabled || working"
          :taggable="canCreate"
          :push-tags="false"
          :create-option="createOption"
          @input="handleInput"
        >
          <template #custom-option="option">
            <template v-if="option.__create__">
              <span class="dictionary-option__create">+</span>
              <span>Create “{{ option.name }}”</span>
            </template>
            <template v-else>
              <span class="dictionary-option__dot" :style="{ backgroundColor: option.color }"></span>
              <span>{{ option.name }}</span>
            </template>
          </template>
        </app-select>
      </div>
    </div>
  </app-form-group>
</template>

<script>
import { postSupportTicketDictionary } from '@/http'
import { apiError } from '../ticketState'
import { SUPPORT_TAG_COLORS } from './tagPalette'

export default {
  name: 'SupportTicketDictionaryField',
  props: {
    value: { default: null },
    options: { type: Array, default: () => [] },
    kind: { type: String, required: true },
    label: { type: String, required: true },
    singular: { type: String, required: true },
    placeholder: { type: String, default: 'Select an option' },
    multiple: Boolean,
    disabled: Boolean,
    canCreate: Boolean,
    parentPayload: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      palette: SUPPORT_TAG_COLORS,
      selectKey: 0,
      working: false
    }
  },
  methods: {
    createOption(name) {
      return { name: (name || '').trim(), color: this.palette[7], __create__: true }
    },
    handleInput(value) {
      const values = this.multiple ? (value || []) : [value]
      const draft = values.find(item => item?.__create__)
      if (draft) this.create(draft.name, values.filter(item => !item?.__create__))
      else {
        this.$emit('input', value)
      }
    },
    create(name, selectedValues = []) {
      name = (name || '').trim()
      if (!name || this.working) return
      this.working = true
      postSupportTicketDictionary(this.kind, {
        name,
        color: this.palette[7],
        ...this.parentPayload
      }).then(response => {
        const created = response.data
        this.$emit('created', created)
        if (this.multiple) this.$emit('input', [...selectedValues, created])
        else this.$emit('input', created)
      }).catch(error => {
        this.$notify({ type: 'error', text: apiError(error) })
        this.selectKey += 1
      }).finally(() => { this.working = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.dictionary-field { position: relative; }
.dictionary-field__control { min-width: 0; }
.dictionary-field__control > :first-child { min-width: 0; }
.dictionary-option__dot { width: 9px; height: 9px; flex: 0 0 9px; margin-right: 8px; border-radius: 50%; }
.dictionary-option__create { display: inline-grid; width: 18px; height: 18px; margin-right: 5px; place-items: center; border-radius: 5px; background: $ui-blue-soft; color: $ui-blue; font-weight: 700; }
</style>
